import React, { useContext } from 'react';
import AmplitudeContext from './AmplitudeContext';

export default function useAmplitudeClient() {
  const client = useContext(AmplitudeContext);
  return client;
}
